export const CONTACT_TOPICS = ['Estate review', '12c → 14c upgrade', 'Migration', 'Support retainer', 'Tool assessment', 'Something else'] as const;
export type ContactTopic = (typeof CONTACT_TOPICS)[number];

const TOPIC_FROM_QUERY: Record<string, ContactTopic> = {
  upgrade: '12c → 14c upgrade',
  migration: 'Migration',
  retainer: 'Support retainer',
  scoping: 'Something else',
  other: 'Something else',
  'estate-review': 'Estate review',
  'tool-assessment': 'Tool assessment',
};

// Keep older bookmarked CTAs useful, while accepting only known context keys.
export function contactTopic(search: string) {
  const params = new URLSearchParams(search);
  const requested = params.get('topic');
  const legacyIntent = params.get('intent');
  const key = requested ?? (legacyIntent === 'scoping' ? 'scoping' : legacyIntent === 'engineer' ? 'other' : '');
  const topicKey = Object.prototype.hasOwnProperty.call(TOPIC_FROM_QUERY, key) ? key : '';
  return {
    topicKey,
    topic: topicKey ? TOPIC_FROM_QUERY[topicKey] : 'Something else' as ContactTopic,
    scoping: topicKey === 'scoping',
  };
}
